/**
 * Check if an input is a "true" object.
 *
 * @param input {any} Input to be checked
 * @returns {boolean} Returns true if the input is an actual object.
 */

export default (input: unknown): boolean =>
    !!input && typeof input === 'object' && input instanceof Object && !Array.isArray(input);
